import React from "react";
import "./home.css"; // Import your CSS file for styling
export const TechStack = () => {
  return (
    <div className="tech-stack">
      <h1 className="section-title">Technologies</h1>
      <div className="tech-icons-container text-center">
        <div className="tech-icons ">
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path fill="#E65100" d="M41,5H7l3,34l14,4l14-4L41,5L41,5z"></path>
              <path fill="#FF6D00" d="M24 8L24 39.9 35.2 36.7 37.7 8z"></path>
              <path
                fill="#FFF"
                d="M24,25v-4h8.6l-0.7,11.5L24,35.1v-4.2l4.1-1.4l0.3-4.5H24z M32.9,17l0.3-4H24v4H32.9z"
              ></path>
              <path
                fill="#EEE"
                d="M24,30.9v4.2l-7.9-2.6L15.7,27h4l0.2,2.5L24,30.9z M19.1,17H24v-4h-9.1l0.7,12H24v-4h-4.6L19.1,17z"
              ></path>
            </svg>
            <div>HTML5</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path fill="#0277BD" d="M41,5H7l3,34l14,4l14-4L41,5L41,5z"></path>
              <path fill="#039BE5" d="M24 8L24 39.9 35.2 36.7 37.7 8z"></path>
              <path
                fill="#FFF"
                d="M33.1 13L24 13 24 17 28.9 17 28.6 21 24 21 24 25 28.4 25 28.1 29.5 24 30.9 24 35.1 31.9 32.5 32.6 21 32.6 21z"
              ></path>
              <path
                fill="#EEE"
                d="M24,13v4h-8.9l-0.3-4H24z M19.4,21l0.2,4H24v-4H19.4z M19.8,27h-4l0.3,5.5l7.9,2.6v-4.2l-4.1-1.4L19.8,27z"
              ></path>
            </svg>
            <div>CSS3</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path fill="#ffd600" d="M6,42V6h36v36H6z"></path>
              <path
                fill="#000001"
                d="M29.538 32.947c.692 1.124 1.444 2.201 3.037 2.201 1.338 0 2.04-.665 2.04-1.585 0-1.101-.726-1.492-2.198-2.133l-.807-.344c-2.329-.988-3.878-2.226-3.878-4.841 0-2.41 1.845-4.244 4.728-4.244 2.053 0 3.528.711 4.592 2.573l-2.514 1.607c-.553-.988-1.151-1.377-2.078-1.377-.946 0-1.545.597-1.545 1.377 0 .964.6 1.354 1.985 1.951l.807.344C36.452 29.645 38 30.839 38 33.523 38 36.415 35.716 38 32.65 38c-2.999 0-4.702-1.505-5.65-3.368L29.538 32.947zM17.952 33.029c.506.906 1.275 1.603 2.381 1.603 1.058 0 1.667-.418 1.667-2.043V22h3.333v11.101c0 3.367-1.953 4.899-4.805 4.899-2.577 0-4.437-1.746-5.195-3.368L17.952 33.029z"
              ></path>
            </svg>
            <div>JavaScript</div>
          </div>
          <div className="tech-icon">
            <img
              width="70"
              height="70"
              src="https://img.icons8.com/external-tal-revivo-color-tal-revivo/96/external-mysql-an-open-source-relational-database-management-system-logo-color-tal-revivo.png"
              alt="external-mysql-an-open-source-relational-database-management-system-logo-color-tal-revivo"
            />
            <div>SQL</div>
          </div>
        </div>
        <div className="tech-icons">
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <g>
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 24 24"
                  to="360 24 24"
                  dur="4s"
                  repeatCount="indefinite"
                />
                <path
                  fill="#80deea"
                  d="M24,34C11.1,34,1,29.6,1,24c0-5.6,10.1-10,23-10c12.9,0,23,4.4,23,10C47,29.6,36.9,34,24,34z M24,16	c-12.6,0-21,4.1-21,8c0,3.9,8.4,8,21,8s21-4.1,21-8C45,20.1,36.6,16,24,16z"
                ></path>
                <path
                  fill="#80deea"
                  d="M15.1,44.6c-1,0-1.8-0.2-2.6-0.7C7.6,41.1,8.9,30.2,15.3,19l0,0c3-5.2,6.7-9.6,10.3-12.4c3.9-3,7.4-3.9,9.8-2.5	c2.5,1.4,3.4,4.9,2.8,9.8c-0.6,4.6-2.6,10-5.6,15.2c-3,5.2-6.7,9.6-10.3,12.4C19.7,43.5,17.2,44.6,15.1,44.6z M32.9,5.4	c-1.6,0-3.7,0.9-6,2.7c-3.4,2.7-6.9,6.9-9.8,11.9l0,0c-6.3,10.9-6.9,20.3-3.6,22.2c1.7,1,4.5,0.1,7.6-2.3c3.4-2.7,6.9-6.9,9.8-11.9	c2.9-5,4.8-10.1,5.4-14.4c0.5-4-0.1-6.8-1.8-7.8C34,5.6,33.5,5.4,32.9,5.4z"
                ></path>
                <path
                  fill="#80deea"
                  d="M33,44.6c-5,0-12.2-6.1-17.6-15.6C8.9,17.8,7.6,6.9,12.5,4.1l0,0C17.4,1.3,26.2,7.8,32.7,19	c3,5.2,5,10.6,5.6,15.2c0.7,4.9-0.3,8.3-2.8,9.8C34.7,44.4,33.9,44.6,33,44.6z M13.5,5.8c-3.3,1.9-2.7,11.3,3.6,22.2	c6.3,10.9,14.1,16.1,17.4,14.2c1.7-1,2.3-3.8,1.8-7.8c-0.6-4.3-2.5-9.4-5.4-14.4C24.6,9.1,16.8,3.9,13.5,5.8L13.5,5.8z"
                ></path>
                <circle cx="24" cy="24" r="4" fill="#80deea"></circle>
              </g>
            </svg>

            <div>React</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path
                fill="#5d4037"
                d="M42,17.3C42,37.8,24,44,24,44S6,37.8,6,17.3c0-2.5,0.2-4.6,0.4-6.3c0.3-2.5,2-4.5,4.4-5.1 C13.9,5,18.8,4,24,4s10.1,1,13.3,1.9c2.4,0.6,4.1,2.7,4.4,5.1C41.8,12.7,42,14.9,42,17.3z"
              ></path>
              <path
                fill="#4caf50"
                d="M24,7c4.9,0,9.5,1,12.5,1.8c1.2,0.3,2,1.3,2.2,2.6c0.2,1.9,0.3,3.9,0.3,5.9c0,15.6-11.5,21.9-15,23.4 c-3.5-1.6-15-7.9-15-23.4c0-2,0.1-4,0.3-5.9c0.1-1.3,1-2.3,2.2-2.6C14.5,8,19.1,7,24,7 M24,4c-5.2,0-10.1,1-13.3,1.9 C8.4,6.5,6.6,8.6,6.4,11C6.2,12.7,6,14.9,6,17.3C6,37.8,24,44,24,44s18-6.2,18-26.7c0-2.5-0.2-4.6-0.4-6.3c-0.3-2.5-2-4.5-4.4-5.1 C34.1,5,29.2,4,24,4L24,4z"
              ></path>
              <path fill="#dcedc8" d="M23 28H25V36H23z"></path>
              <path
                fill="#4caf50"
                d="M24,10c0,0-6,5-6,13c0,5.2,3.3,8.5,5,10l1-3l1,3c1.7-1.5,5-4.8,5-10C30,15,24,10,24,10z"
              ></path>
              <path
                fill="#81c784"
                d="M24,10c0,0-6,5-6,13c0,5.2,3.3,8.5,5,10l1-3V10z"
              ></path>
            </svg>
            <div>MongoDB</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path
                fill="#0277bd"
                d="M24.047,5c-1.555,0.005-2.633,0.142-3.936,0.367c-3.848,0.67-4.549,2.077-4.549,4.67V14h9v2H15.22	h-4.35c-2.636,0-4.943,1.242-5.674,4.219c-0.826,3.417-0.863,5.557,0,9.125C5.851,32.005,7.294,34,9.931,34h3.632v-5.104	c0-2.966,2.686-5.896,5.764-5.896h7.236c2.523,0,5-1.862,5-4.377v-8.586c0-2.439-1.759-4.263-4.218-4.672	C27.406,5.359,25.589,4.994,24.047,5z M19.063,9c0.821,0,1.5,0.677,1.5,1.502c0,0.833-0.679,1.498-1.5,1.498	c-0.837,0-1.5-0.664-1.5-1.498C17.563,9.68,18.226,9,19.063,9z"
              ></path>
              <path
                fill="#ffc107"
                d="M23.078,43c1.555-0.005,2.633-0.142,3.936-0.367c3.848-0.67,4.549-2.077,4.549-4.67V34h-9v-2h9.343	h4.35c2.636,0,4.943-1.242,5.674-4.219c0.826-3.417,0.863-5.557,0-9.125C41.274,15.995,39.831,14,37.194,14h-3.632v5.104	c0,2.966-2.686,5.896-5.764,5.896h-7.236c-2.523,0-5,1.862-5,4.377v8.586c0,2.439,1.759,4.263,4.218,4.672	C19.719,42.641,21.536,43.006,23.078,43z M28.063,39c-0.821,0-1.5-0.677-1.5-1.502c0-0.833,0.679-1.498,1.5-1.498	c0.837,0,1.5,0.664,1.5,1.498C29.563,38.32,28.899,39,28.063,39z"
              ></path>
            </svg>
            <div>Python</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 80 80"
            >
              <path
                fill="#dcd5f2"
                d="M40,61.5C18.22,61.5,0.5,51.855,0.5,40S18.22,18.5,40,18.5S79.5,28.145,79.5,40S61.78,61.5,40,61.5z"
              ></path>
              <path
                fill="#8b75a1"
                d="M40,19c21.505,0,39,9.421,39,21S61.505,61,40,61S1,51.579,1,40S18.495,19,40,19 M40,18 C17.909,18,0,27.85,0,40s17.909,22,40,22s40-9.85,40-22S62.091,18,40,18L40,18z"
              ></path>
              <path
                fill="#36404d"
                d="M25.112 34c1.725 0 3.214.622 4.084 1.706.749.934.981 2.171.668 3.577C29.023 43.074 27.395 44 21.57 44h-4.14l1.75-10H25.112M25.112 32H17.5L14 52h2l1.056-6h4.515c5.863 0 9.053-.905 10.246-6.284C32.842 35.096 29.436 32 25.112 32L25.112 32zM61.112 34c1.725 0 3.214.622 4.084 1.706.749.934.981 2.171.668 3.577C65.023 43.074 63.395 44 57.57 44h-4.14l1.75-10H61.112M61.112 32H53.5L50 52h2l1.056-6h4.515c5.863 0 9.053-.905 10.246-6.284C68.842 35.096 65.436 32 61.112 32L61.112 32z"
              ></path>
              <g>
                <path
                  fill="#36404d"
                  d="M49.072,33.212C48.193,32.348,46.644,32,44.334,32h-5.538L40,26h-2.1L34,46h1.99l2.388-12h0.419 h5.538c2.338,0,3.094,0.4,3.335,0.637c0.343,0.338,0.424,1.226,0.217,2.363l-1.767,9h2.106l1.626-8.63 C50.199,35.462,49.936,34.062,49.072,33.212z"
                ></path>
              </g>
            </svg>
            <div>PHP</div>
          </div>
        </div>
        <div className="tech-icons">
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path
                fill="#388e3c"
                d="M17.204 19.122l-4.907 2.715C12.113 21.938 12 22.126 12 22.329v5.433c0 .203.113.39.297.492l4.908 2.717c.183.101.41.101.593 0l4.907-2.717C22.887 28.152 23 27.965 23 27.762v-5.433c0-.203-.113-.39-.297-.492l-4.906-2.715c-.092-.051-.195-.076-.297-.076-.103 0-.205.025-.297.076M42.451 24.013l-.818.452c-.031.017-.049.048-.049.082v.906c0 .034.019.065.049.082l.818.453c.031.017.068.017.099 0l.818-.453c.03-.017.049-.048.049-.082v-.906c0-.034-.019-.065-.05-.082l-.818-.452C42.534 24.004 42.517 24 42.5 24S42.466 24.004 42.451 24.013"
              ></path>
              <path
                fill="#37474f"
                d="M35.751,13.364l-2.389-1.333c-0.075-0.042-0.167-0.041-0.241,0.003 c-0.074,0.044-0.12,0.123-0.12,0.209L33,20.295l-2.203-1.219C30.705,19.025,30.602,19,30.5,19c-0.102,0-0.205,0.025-0.297,0.076 h0.001l-4.907,2.715C25.113,21.892,25,22.08,25,22.282v5.433c0,0.203,0.113,0.39,0.297,0.492l4.908,2.717 c0.183,0.101,0.41,0.101,0.593,0l4.907-2.717C35.887,28.106,36,27.918,36,27.715V13.788C36,13.612,35.904,13.45,35.751,13.364z M32.866,26.458l-2.23,1.235c-0.083,0.046-0.186,0.046-0.269,0l-2.231-1.235C28.051,26.412,28,26.326,28,26.234v-2.47 c0-0.092,0.051-0.177,0.135-0.224l2.231-1.234h-0.001c0.042-0.023,0.088-0.034,0.135-0.034c0.047,0,0.093,0.012,0.135,0.034 l2.23,1.234C32.949,23.587,33,23.673,33,23.765v2.47C33,26.326,32.949,26.412,32.866,26.458z"
              ></path>
              <path
                fill="#2e7d32"
                d="M17.204,19.122L12,27.762c0,0.203,0.113,0.39,0.297,0.492l4.908,2.717 c0.183,0.101,0.41,0.101,0.593,0L23,22.329c0-0.203-0.113-0.39-0.297-0.492l-4.906-2.715c-0.092-0.051-0.195-0.076-0.297-0.076 c-0.103,0-0.205,0.025-0.297,0.076"
              ></path>
              <path
                fill="#4caf50"
                d="M17.204,19.122l-4.907,2.715C12.113,21.938,12,22.126,12,22.329l5.204,8.642 c0.183,0.101,0.41,0.101,0.593,0l4.907-2.717C22.887,28.152,23,27.965,23,27.762l-5.203-8.64c-0.092-0.051-0.195-0.076-0.297-0.076 c-0.103,0-0.205,0.025-0.297,0.076"
              ></path>
              <path
                fill="#37474f"
                d="M47.703 21.791l-4.906-2.715C42.705 19.025 42.602 19 42.5 19c-.102 0-.205.025-.297.076h.001l-4.907 2.715C37.114 21.892 37 22.084 37 22.294v5.411c0 .209.114.402.297.503l4.908 2.717c.184.102.409.102.593 0l2.263-1.253c.207-.115.206-.412-.002-.526l-4.924-2.687C40.052 26.412 40 26.325 40 26.231v-2.466c0-.092.05-.177.13-.221l2.235-1.236h-.001c.042-.023.088-.034.135-.034.047 0 .093.012.135.034l2.235 1.237c.08.044.13.129.13.221v2.012c0 .086.046.166.121.209.075.042.167.042.242-.001l2.398-1.393c.148-.086.24-.245.24-.417v-1.88C48 22.085 47.886 21.892 47.703 21.791zM10.703 21.791l-4.906-2.715C5.705 19.025 5.602 19 5.5 19c-.102 0-.205.025-.297.076h.001l-4.907 2.715C.114 21.892 0 22.084 0 22.294v7.465c0 .086.046.166.121.209.075.042.167.042.242-.001l2.398-1.393C2.909 28.488 3 28.329 3 28.157v-4.393c0-.092.05-.177.13-.221l2.235-1.236H5.365c.042-.023.088-.034.135-.034.047 0 .093.012.135.034l2.235 1.237C7.95 23.588 8 23.673 8 23.765v4.393c0 .172.091.331.24.417l2.398 1.393c.075.043.167.043.242.001C10.954 29.925 11 29.845 11 29.759v-7.464C11 22.085 10.886 21.892 10.703 21.791z"
              ></path>
            </svg>
            <div>NodeJS</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <defs>
                <style>{`
        @keyframes eyeBlink {
          0%, 97%, 100% { opacity: 1; }
          98%, 99% { opacity: 0; }
        }
        @keyframes eyeCover {
          0%, 97%, 100% { opacity: 0; }
          98%, 99% { opacity: 1; }
        }
      `}</style>
              </defs>

              {/* Main body */}
              <path
                fill="#03A9F4"
                d="M40,20c0.391-1.735-0.092-3.78-2.5-6c-3.914,3.543-2.795,7.227-1.5,9c0,0-0.166,1-4,1S2,24,2,24S0.167,40,18,40c15.593,0,19.973-12.003,20.828-15.076C39.182,24.972,39.579,25.003,40,25c2.147-0.017,4.93-1.171,6-5.484C43.162,18.533,41.339,18.978,40,20z"
              />
              <path
                fill="#0288D1"
                d="M2.165,28C2.9,32.739,5.983,40,18,40c12.185,0,17.523-7.33,19.682-12H2.165z"
              />
              <path
                fill="#81D4FA"
                d="M19.812,39.938C18.892,39.616,14.74,38.848,14,33c-4.209,1.863-7.938,1.375-9.579,1.008C6.583,37.237,10.591,40,18,40C18.623,40,19.224,39.976,19.812,39.938z"
              />

              {/* Eye Group */}
              <g>
                <path
                  fill="#FFF"
                  d="M18 30A2 2 0 1 0 18 34A2 2 0 1 0 18 30Z"
                  style={{ animation: "eyeBlink 2.5s infinite" }}
                />
                <path
                  fill="#03A9F4"
                  d="M18 30A2 2 0 1 0 18 34A2 2 0 1 0 18 30Z"
                  style={{ animation: "eyeCover 2.5s infinite" }}
                />
              </g>

              <path
                fill="#37474F"
                d="M14.914,33.597c0.224,0.505,0.02,1.162-0.51,1.318c-3.301,0.973-6.146,1.102-8.297,1.102c-0.644-0.619-1.194-1.279-1.656-1.963c2.585,0,6.71-0.12,9.144-0.966C14.117,32.906,14.69,33.09,14.914,33.597z M2,27c0,0,1.875,0.125,3-1c1.875,1.688,5.94,1.088,7,0c1.063,1.688,6.938,1.375,8,0c1.25,1.438,6.625,1.75,8,0c0.479,1.461,6.819,1.874,8,0c1.061,1.088,5.063,1.938,7.311,0C43.875,27.188,46,27,46,27v1H2 M17,32c0,0.552,0.448,1,1,1s1-0.448,1-1s-0.448-1-1-1S17,31.448,17,32z"
              />
              <path
                fill="#01579B"
                d="M11,24H6v-5h5V24z M21,19h-5v5h5V19z M31,19h-5v5h5V19z M16,14h-5v5h5V14z M26,14h-5v5h5V14z"
              />
              <path
                fill="#0288D1"
                d="M16,24h-5v-5h5V24z M26,19h-5v5h5V19z M26,9h-5v5h5V9z M21,14h-5v5h5V14z"
              />
            </svg>
            <div>Docker</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path
                fill="#169154"
                d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"
              ></path>
              <path
                fill="#18482a"
                d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"
              ></path>
              <path
                fill="#0c8045"
                d="M14 15.003H29V24.005000000000003H14z"
              ></path>
              <path fill="#17472a" d="M14 24.005H29V33.055H14z"></path>
              <g>
                <path
                  fill="#29c27f"
                  d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"
                ></path>
                <path
                  fill="#27663f"
                  d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"
                ></path>
                <path
                  fill="#19ac65"
                  d="M29 15.003H44V24.005000000000003H29z"
                ></path>
                <path fill="#129652" d="M29 24.005H44V33.055H29z"></path>
              </g>

              <path
                fill="#0c7238"
                d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"
              ></path>
              <path
                fill="#fff"
                d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"
              ></path>
            </svg>
            <div>Data Analytics</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 100 100"
            >
              <path
                fill="#6e78ac"
                d="M83.242,60.482c-6.349,1.924-9.957-0.415-9.957-0.415s-0.006,0-0.007,0l-0.394-0.488	c0.131-0.117,0.264-0.242,0.4-0.381l0.019-0.017l-0.001-0.002c5.639-5.753,15.838-29.562,9.749-37.378	c-8.553-10.979-25.66-5.745-25.66-5.745l0.064,0.183c-4.889-1.666-9.947-1.625-13.851,0.838c-0.661,0.417-1.273,0.873-1.844,1.357	l0.014-0.187c0,0-8.149-3.213-15.851-2.383c-7.954,0.857-12.319,6.83-12.319,15.83s6.17,30.553,10.17,34.553s6,2,7,1	c0.896-0.896,6.588-7.387,7.771-8.738c2.143,1.4,4.575,1.743,5.983,1.748c-0.184,0.991-1.31,4.988-7.562,5.714	c-2.809,0.447-1.915,2.298,0.128,2.872c2.002,0.563,8.415,1.967,12.335-3.509c-0.052,3.397-0.183,9.771,0.304,15.126	c0.574,6.319,3.983,8.376,6.511,8.713c7.878,1.048,10.628-4.308,11.394-6.702c0.702-2.194,1.839-10.809,2.213-16.588l0.503-0.089	l-0.004,0.05c8.106,1.277,12.734-1.66,14.362-3.191C86.338,61.12,85.349,59.844,83.242,60.482z"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-miterlimit="10"
                stroke-width="2"
                d="M39,58c0,0-6.75,7.562-7.75,8.562s-3,3-7-1	s-10.25-25-10.25-34s4.234-15.518,12.188-16.375C33.89,14.358,42,18,42,18"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-miterlimit="10"
                stroke-width="2"
                d="M71.213,56.947	c2.681-2.106,2.968-8.713,2.489-12.734c-0.479-4.021,0.331-6.392,0.235-11.275C70.682,19.629,53.612,10.839,43.75,17.062	s-8.854,20.137-8.375,24.062s-2.444,6.539-0.625,12.188s7.644,6.698,10.037,6.698c2.394,0,4.883,0.957,4.883,3.543	s-0.287,10.34,0.287,16.66c0.574,6.319,3.983,8.376,6.511,8.713c7.878,1.048,10.628-4.309,11.394-6.702s2.052-12.439,2.298-18.096	c0.191-4.404,3.351-4.309,3.351-4.309s3.608,2.339,9.957,0.415c2.106-0.638,3.096,0.638,1.468,2.17	c-1.628,1.532-6.017,4.56-14.124,3.283"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-miterlimit="10"
                stroke-width="2"
                d="M74.085,33.617c0,0-6.523-2.242-8.71,2.195	c-1.893,3.841,3.987,18.294,8.199,23.592"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-miterlimit="10"
                stroke-width="2"
                d="M34.574,36.617c0,0,7.652-4.612,11.801-1.867	S48.936,48.106,47.149,52c-1.787,3.894-2.362,7.787-2.362,7.787s-0.447,5.106-7.596,5.936c-2.809,0.447-1.915,2.298,0.128,2.872	c2.043,0.574,8.681,2.043,12.574-3.83"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2"
                d="M57.617,15.809	c0,0,17.356-4.174,25.383,5.629c6.553,8.003-4.766,33.882-10.191,38.158"
              ></path>
              <path
                fill="#1f212b"
                d="M69.154,38.037c-1.652,0.168-3.423-1.939-0.096-2.346C72.177,35.31,71.323,37.817,69.154,38.037z"
              ></path>
              <path
                fill="#1f212b"
                d="M43.223,38.848c-1.824-0.23-3.212-2.945,0.481-2.556C47.165,36.657,45.619,39.151,43.223,38.848z"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M39.492,27.447	c-0.236,0.688-0.451,1.425-0.641,2.213"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M47.808,18.479	c-2.789,0.876-5.771,2.939-7.731,7.456"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M55.064,18.298	c0,0-2.11-0.621-4.851-0.319"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M20.148,21.817	c-1.921,2.074-3.369,5.451-3.173,10.945"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M28.319,18.553	c0,0-3.417-0.258-6.503,1.833"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M53.549,82.6	c0.649,1.702,1.858,3.266,4.1,3.613"
              ></path>
              <path
                fill="none"
                stroke="#1f212b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M52.83,77.596	c0,0-0.095,1.358,0.186,3.001"
              ></path>
            </svg>
            <div>Postgress</div>
          </div>
        </div>
        <div className="tech-icons">
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 200 100"
            >
              <text
                x="100"
                y="40"
                font-family="Amazon Ember, sans-serif"
                font-size="48"
                fill="#4A4F5A"
                text-anchor="middle"
                dominant-baseline="middle"
              >
                aws
              </text>

              <defs>
                <path
                  id="smileCurve"
                  d="M60,60 C90,90 110,90 140,60"
                  fill="none"
                />
                <marker
                  id="arrowhead"
                  viewBox="0 0 10 10"
                  refX="9"
                  refY="5"
                  markerUnits="strokeWidth"
                  markerWidth="6"
                  markerHeight="6"
                  orient="auto"
                >
                  <path d="M0,0 L10,5 L0,10 Z" fill="#FF9900" />
                </marker>
              </defs>

              <path
                d="M60,60 C90,90 110,90 140,60"
                stroke="#FF9900"
                stroke-width="6"
                fill="none"
                marker-end="url(#arrowhead)"
                stroke-dasharray="240"
                stroke-dashoffset="240"
              >
                <animate
                  attributeName="stroke-dashoffset"
                  from="240"
                  to="0"
                  dur="2s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>

            <div>Amazon AWS</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <g>
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 24 24"
                  to="360 24 24"
                  dur="4s"
                  repeatCount="indefinite"
                />
                <path
                  fill="#80deea"
                  d="M24,34C11.1,34,1,29.6,1,24c0-5.6,10.1-10,23-10c12.9,0,23,4.4,23,10C47,29.6,36.9,34,24,34z M24,16	c-12.6,0-21,4.1-21,8c0,3.9,8.4,8,21,8s21-4.1,21-8C45,20.1,36.6,16,24,16z"
                ></path>
                <path
                  fill="#80deea"
                  d="M15.1,44.6c-1,0-1.8-0.2-2.6-0.7C7.6,41.1,8.9,30.2,15.3,19l0,0c3-5.2,6.7-9.6,10.3-12.4c3.9-3,7.4-3.9,9.8-2.5	c2.5,1.4,3.4,4.9,2.8,9.8c-0.6,4.6-2.6,10-5.6,15.2c-3,5.2-6.7,9.6-10.3,12.4C19.7,43.5,17.2,44.6,15.1,44.6z M32.9,5.4	c-1.6,0-3.7,0.9-6,2.7c-3.4,2.7-6.9,6.9-9.8,11.9l0,0c-6.3,10.9-6.9,20.3-3.6,22.2c1.7,1,4.5,0.1,7.6-2.3c3.4-2.7,6.9-6.9,9.8-11.9	c2.9-5,4.8-10.1,5.4-14.4c0.5-4-0.1-6.8-1.8-7.8C34,5.6,33.5,5.4,32.9,5.4z"
                ></path>
                <path
                  fill="#80deea"
                  d="M33,44.6c-5,0-12.2-6.1-17.6-15.6C8.9,17.8,7.6,6.9,12.5,4.1l0,0C17.4,1.3,26.2,7.8,32.7,19	c3,5.2,5,10.6,5.6,15.2c0.7,4.9-0.3,8.3-2.8,9.8C34.7,44.4,33.9,44.6,33,44.6z M13.5,5.8c-3.3,1.9-2.7,11.3,3.6,22.2	c6.3,10.9,14.1,16.1,17.4,14.2c1.7-1,2.3-3.8,1.8-7.8c-0.6-4.3-2.5-9.4-5.4-14.4C24.6,9.1,16.8,3.9,13.5,5.8L13.5,5.8z"
                ></path>
                <circle cx="24" cy="24" r="4" fill="#80deea"></circle>
              </g>
            </svg>

            <div>React-Native</div>
          </div>
          <div className="tech-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="70"
              height="70"
              viewBox="0 0 48 48"
            >
              <path
                fill="#bdbdbd"
                d="M23.933 2L3 9.285 6.308 36.408 23.955 46 41.693 36.278 45 9.156z"
              ></path>
              <path
                fill="#b71c1c"
                d="M42.818 10.527L24 4.135 24 43.695 39.832 35.017z"
              ></path>
              <path
                fill="#dd2c00"
                d="M23.941 4.115L5.181 10.644 8.168 35.143 23.951 43.721 24 43.695 24 4.135z"
              ></path>
              <path
                fill="#bdbdbd"
                d="M24 5.996L24 15.504 32.578 34 36.987 34z"
              ></path>
              <path
                fill="#eee"
                d="M11.013 34L15.422 34 24 15.504 24 5.996z"
              ></path>
              <path fill="#bdbdbd" d="M24 24H30V28H24z"></path>
              <path fill="#eee" d="M18 24H24V28H18z"></path>
            </svg>
            <div>AngularJS</div>
          </div>
          <div className="tech-icon">
            <svg
              width="70"
              height="70"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="16"
                y="16"
                width="32"
                height="32"
                rx="4"
                ry="4"
                fill="#90caf9"
                stroke="#1976d2"
                stroke-width="2"
              />
              <rect
                x="20"
                y="4"
                width="24"
                height="16"
                rx="3"
                ry="3"
                fill="#e3f2fd"
                stroke="#1976d2"
                stroke-width="2"
              />

              <circle cx="32" cy="0" r="3" fill="#ff5252">
                <animate
                  attributeName="r"
                  values="3;4;3"
                  dur="1.5s"
                  repeatCount="indefinite"
                />
              </circle>
              <line
                x1="32"
                y1="4"
                x2="32"
                y2="0"
                stroke="#ff5252"
                stroke-width="2"
              />

              <circle
                cx="26"
                cy="12"
                r="3"
                fill="#ffffff"
                stroke="#000"
                stroke-width="1"
              >
                <animate
                  attributeName="r"
                  values="3;1;3"
                  dur="4s"
                  repeatCount="indefinite"
                  begin="0.5s"
                />
              </circle>
              <circle
                cx="38"
                cy="12"
                r="3"
                fill="#ffffff"
                stroke="#000"
                stroke-width="1"
              >
                <animate
                  attributeName="r"
                  values="3;1;3"
                  dur="4s"
                  repeatCount="indefinite"
                  begin="0.5s"
                />
              </circle>

              <rect
                x="18"
                y="28"
                width="28"
                height="16"
                fill="#fff9c4"
                stroke="#fbc02d"
                stroke-width="2"
              />
              <line
                x1="32"
                y1="28"
                x2="32"
                y2="44"
                stroke="#f57f17"
                stroke-width="1"
              />
              <line
                x1="22"
                y1="34"
                x2="42"
                y2="34"
                stroke="#f57f17"
                stroke-width="1"
              >
                <animate
                  attributeName="x1"
                  values="22;23;22"
                  dur="2s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="x2"
                  values="42;41;42"
                  dur="2s"
                  repeatCount="indefinite"
                />
              </line>

              <line
                x1="16"
                y1="30"
                x2="8"
                y2="26"
                stroke="#1976d2"
                stroke-width="2"
              />
              <line
                x1="48"
                y1="30"
                x2="56"
                y2="26"
                stroke="#1976d2"
                stroke-width="2"
              />
            </svg>

            <div>Deep-Learing</div>
          </div>
        </div>
      </div>

      <div class="dots d-flex gap-1 align-items-baseline">
        <p className="display-6 font-serif">Always Learning </p>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default TechStack;
